import { render, staticRenderFns } from "./lrBarpercent.vue?vue&type=template&id=81bb8d10&"
import script from "./lrBarpercent.vue?vue&type=script&lang=js&"
export * from "./lrBarpercent.vue?vue&type=script&lang=js&"
import style0 from "./lrBarpercent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports